module.exports = __webpack_public_path__ + "static/media/amusement(3).5c04cb70.PNG";